@if (sideNavService.open()) {
  <div class="tw-h-px tw-w-full tw-my-2 tw-bg-border-nav-divider"></div>
}
